import { httpClient } from '@/infra/protocols/http';
import { IProjectDTO } from '@/modules/projects/dtos/project.dto';
import { IProject } from '@/modules/projects/entities/project.entity';
import { ProjectMapper } from '@/modules/projects/mappers/project.mapper';

export async function getProjects(): Promise<GetProjectsService.Response> {
  const response = await httpClient.get<IProjectDTO[]>(`/v1/projetos`);
  return response.map(ProjectMapper.toPresentation);
}

export namespace GetProjectsService {
  export type Response = IProject[];
}
